

























































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import DataPanel from '@/components/DataPanel.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import { RoleApi, LoginApi } from '@/http';
@Component({
    components: { BaseContainer, DataPanel, PageDescribe },
})
export default class RoleManagement extends Vue {
    public $refs: {
        vtree: HTMLFormElement;
        rolesForm: HTMLFormElement;
    };
    /** 树默认不展开 */
    public defaultExpand = false;
    /** 是否展开 */
    public isExpand: boolean = false;
    // 验证规则
    public formRules = formRules;
    public roleVisible: boolean = false;
    public roleTitle: string = '';
    public loading: boolean = false;
    public rolesForm = {
        value: '',
        IsEditName: undefined,
    };
    public roleList = [];
    public treeData = [];
    public form = {
        id: '1',
        name: '',
    };
    /** 功能权限选中 */
    public checked = [];
    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    public setColor: boolean = false;

    mounted() {
        this.loadRolesList();
        this.loadPermissionTree();
        // this.form.name = this.roleList[0].name;
    }
    //获取角色列表
    public async loadRolesList() {
        this.loading = true;
        await RoleApi.GetRolesList()
            .then((res) => {
                this.roleList = res.data;
                this.loading = false;
                if (!this.form.name) {
                    this.form.name = this.roleList[0].name;
                    this.roleChange(this.form.name);
                }
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    //获取权限树
    public async loadPermissionTree() {
        this.loading = true;
        await LoginApi.GetPermissionTree({ type: 1 })
            .then((res) => {
                this.treeData = res.permissions;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            });
    }

    addRole() {
        this.roleTitle = '新增角色';
        this.rolesForm.value = '';
        this.rolesForm.IsEditName = undefined;
        this.roleVisible = true;
    }
    editRole() {
        this.roleTitle = '编辑角色';
        this.rolesForm.value = this.roleName;
        this.rolesForm.IsEditName = true;
        this.roleVisible = true;
    }
    public srowTy: string = '';
    delRole() {
        this.setColor = true;
        this.srowTy = 'a';
        this.dialogConfig = {
            title: '删除该角色',
            show: true,
        };
    }
    async confirmOk() {
        if (this.srowTy == 'a') {
            this.loading = true;
            RoleApi.DelRole(this.roleId)
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功！',
                    });
                    this.loading = false;
                    this.loadRolesList();
                    if (this.roleList.length > 0) {
                        this.form.name = this.roleList[0].name;
                        this.roleChange(this.form.name);
                    }
                })
                .catch((error) => {
                    this.loading = false;
                });
        } else if (this.srowTy == 'b') {
            this.loading = true;
            this.permissionIds = this.permissionIdsArr.join(',');
            RoleApi.EditRole(this.roleId, { value: this.permissionIds, IsEditName: false })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '提交成功',
                        type: 'success',
                    });
                    this.loading = false;
                    this.$emit('reload');
                })
                .catch((error) => {
                    this.loading = false;
                });
        }
        this.dialogConfig = {
            show: false,
        };
    }
    //角色保存
    public save() {
        this.loading = true;
        if (this.roleTitle == '新增角色') {
            this.$refs.rolesForm.validate((valid) => {
                if (valid) {
                    RoleApi.AddRole({ ...this.rolesForm })
                        .then((res) => {
                            this.roleVisible = false;
                            this.loading = false;
                            this.loadRolesList();
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        } else {
            this.$refs.rolesForm.validate((valid) => {
                if (valid) {
                    RoleApi.EditRole(this.roleId, { ...this.rolesForm })
                        .then((res) => {
                            this.roleVisible = false;
                            this.loading = false;
                            this.loadRolesList().then(() => {
                                this.form.name = this.rolesForm.value;
                                this.roleChange(this.form.name);
                            });
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        }
    }
    //取消
    cancel() {
        this.$refs.rolesForm.resetFields();
        this.rolesForm.value = '';
        this.rolesForm.IsEditName = '';
        this.roleVisible = false;
    }
    //选中的 Radio label 值
    public roleId: string = '';
    public roleName: string = '';
    roleChange(value) {
        //权限树折叠
        this.setCheckedKeys();
        //清空选中项
        this.checked.length = 0;
        this.$refs.vtree.setCheckedKeys([]);
        //获取对应id
        this.roleList.forEach((e) => {
            if (e.name == value) {
                this.roleId = e.id;
                this.roleName = e.name;
            }
        });
        //获取已选中权限并勾选
        this.isExpand = false;
        RoleApi.GetRoleDetail(this.roleId)
            .then((res) => {
                this.checked = res.menuPermissions ? res.menuPermissions.split(',') : [];
                this.permissionIdsArr = res.menuPermissions ? res.menuPermissions.split(',') : [];
            })
            .catch((err) => {});
    }
    /** 全部展开 */
    public setCheckedNodes() {
        this.defaultExpand = true; //展开所有节点
        this.isExpand = true;
        for (var i = 0; i < this.$refs['vtree'].store._getAllNodes().length; i++) {
            this.$refs['vtree'].store._getAllNodes()[i].expanded = this.defaultExpand;
        }
    }

    /** 全部折叠 */
    public setCheckedKeys() {
        this.defaultExpand = false;
        this.isExpand = false;
        for (var i = 0; i < this.$refs['vtree'].store._getAllNodes().length; i++) {
            this.$refs['vtree'].store._getAllNodes()[i].expanded = this.defaultExpand;
        }
    }
    //配置选项
    public defaultProps = {
        label: 'name',
        children: 'childList',
    };
    //权限树勾选
    public permissionIdsArr = [];
    /**复选框被点击时触发：传递给 data 属性的数组中该节点所对应的对象、树目前的选中状态对象所包含的四个属性 */
    currentChecked(data, node) {
        //这个方法是勾选父级子级也默认勾选 取消子级不影响父级
        this.childNodesChange(node);
        // 这个方法是勾选子级默认把父级也勾选上
        this.parentNodesChange(node);
        this.checked = this.$refs.vtree.getCheckedNodes();
        this.permissionIdsArr = [];
        this.checked.forEach((item) => {
            this.permissionIdsArr.push(item.key);
        });
    }
    childNodesChange(node) {
        console.log(node.checked, node.childNodes);
        let len = node.childNodes.length;
        if (len > 0) {
            for (let i = 0; i < len; i++) {
                if (!node.checked) {
                    node.childNodes[i].checked = false;
                } else {
                    node.childNodes[i].checked = true;
                }
                this.childNodesChange(node.childNodes[i]);
            }
        }
    }
    parentNodesChange(node) {
        if (node.parent) {
            for (let key in node) {
                if (key == 'parent') {
                    node[key].checked = true;
                    this.parentNodesChange(node[key]);
                }
            }
        }
    }
    //权限树保存
    public permissionIds: string = '';
    saveTreeData() {
        this.setColor = false;
        this.srowTy = 'b';
        this.dialogConfig = {
            title: '保存',
            show: true,
        };
    }
}
